// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___3xCgX","body":"body___7p7Jl","size":"size___wQvhj"};